export default function initialsHelper(text: string, initialsNumber: number = 2 ): string {
  return text
    .trim()
    .split(" ")
    .slice(0, initialsNumber)
    .map(w => w[0])
    .join("")
    .toUpperCase();
}